<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("TAXES.EDIT_TAX") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <tax-form
              :loading="loading"
              :taxData="tax"
              :formErrors="formErrors"
              @taxesubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import TaxForm from "./partials/TaxForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultTax from "./defaultTax";

export default {
  layout: "DashboardLayout",

  components: { TaxForm },
  mixins: [alertLeave],

  data() {
    return {
      tax: cloneDeep(defaultTax),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("taxes/get", id);
        this.tax = this.$store.getters["taxes/tax"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Taxes" });
    },

    viewTax() {
      this.alertLeave = false;
      this.$router.push({ name: "View Tax", params: { id: this.tax.id } });
    },

    async handleSubmit(tax) {
      this.loading = true;

      const taxData = cloneDeep(tax);
      if (!taxData.organization.id) {
        delete taxData.organization;
      }

      try {
        await this.$store.dispatch("taxes/update", taxData);
        this.$notify({
          type: "success",
          message: this.$t("TAXES.TAXES_UPDATED"),
        });
        this.viewTax();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
